<template>
  <FaLayer>
    <FaIcon :icon="['fas', ICON.USER]" transform="grow-8 left-4 up-2" />
    <FaIcon
      color="var(--color-background-500, white)"
      :icon="['fas', ICON.CIRCLE]"
      transform="shrink-5 left-10 down-6"
    />
    <FaIcon :icon="['fas', ICON.CIRCLE]" transform="shrink-6 left-10 down-6" />
    <FaIcon
      color="var(--color-background-500, white)"
      :icon="['fas', ICON.CAMERA]"
      transform="shrink-10 left-10 down-6"
    />
  </FaLayer>
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';
import { FontAwesomeLayers as FaLayer } from '@fortawesome/vue-fontawesome';
</script>
